import React from 'react'

function Help(){
    return (
        <div>Contact tech team for help!</div>
    )
}
export default Help